﻿import { ListResponse, ServiceOptions, RetrieveRequest, RetrieveResponse, serviceRequest } from "@serenity-is/corelib";
import { SqlProcLookupListRequest } from "./SqlProcLookupListRequest";

export namespace SqlProcLookupService {
    export const baseUrl = 'Data/SqlProcLookupParameter';

    export declare function List(request: SqlProcLookupListRequest, onSuccess?: (response: ListResponse<{ [key: string]: any }>) => void, opt?: ServiceOptions<any>): PromiseLike<ListResponse<{ [key: string]: any }>>;
    export declare function Retrieve(request: RetrieveRequest, onSuccess?: (response: RetrieveResponse<{ [key: string]: any }>) => void, opt?: ServiceOptions<any>): PromiseLike<RetrieveResponse<{ [key: string]: any }>>;

    export const Methods = {
        List: "Data/SqlProcLookupParameter/List",
        Retrieve: "Data/SqlProcLookupParameter/Retrieve"
    } as const;

    [
        'List', 
        'Retrieve'
    ].forEach(x => {
        (<any>SqlProcLookupService)[x] = function (r, s, o) {
            return serviceRequest(baseUrl + '/' + x, r, s, o);
        };
    });
}